import {
  Experiment,
  ExperimentClient,
  Variant,
} from '@amplitude/experiment-js-client'
import { getBrandConfig } from '@/config/config'

let experiment: ReturnType<
  typeof Experiment.initializeWithAmplitudeAnalytics
> | null = null
let fetchPromise: Promise<ExperimentClient> | null = null

const getExperiment = () => {
  if (!experiment) {
    const config = getBrandConfig()
    experiment = Experiment.initializeWithAmplitudeAnalytics(
      config.amplitude.deploymentKey,
      {
        fetchOnStart: false,
        serverZone: config.amplitude.region,
      },
    )
  }

  return experiment
}

export const getAllFeatureFlags = async ({ userId }: { userId?: string }) => {
  const exp = getExperiment()

  if (userId) {
    exp.setUser({ user_id: userId })
  }

  if (!fetchPromise) {
    fetchPromise = exp.fetch()
  }

  await fetchPromise

  const allVariants = exp.all()

  const featureFlags: Record<string, { enabled: boolean; variant: Variant }> =
    {}

  Object.entries(allVariants).forEach(([flagKey, variant]) => {
    featureFlags[flagKey] = {
      enabled: variant?.value === 'on',
      variant,
    }
  })

  return featureFlags
}
